import { resetMousyInsertionProfile } from '../mousyInsertionProfileStore';
import { isMousyProfileInsertionActive } from '../selectors/mousyProfileInsertionSelectors';
import { selectorHandlerFactory } from './utility';

export const mousyProfileInsertionHandler = selectorHandlerFactory(isMousyProfileInsertionActive, (change) => {
  if (!change.currentState) {
    resetMousyInsertionProfile();
  }
});
